import React from 'react';
import { render } from 'react-snapshot';
import 'normalize.css'
import './index.css';
import 'overlayscrollbars/css/OverlayScrollbars.css'
import App from './AppZh'

import { supportsWebp } from './utils'

supportsWebp(window).then(res => {
    if (res) {
        window.document.body.className = 'webp'
    }
}).catch(err => {
    console.log(err)
})

console.log("run index zh ==========")

render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root')
);
